import { ConfiguratorOptions, ReturnButton, ReturnButtonVariant } from '@icc/shared/types';
import { Step } from '../steps/step';
import { ComponentType } from '@angular/cdk/overlay';
import { PageComponent } from '@icc/shared/helpers';
import { ConfigurationType } from '@icc/shared/types';
import { SafeHtml } from '@angular/platform-browser';

export const CONFIGURATOR_KEY = 'configurator';

export interface StepOption {
    name: string;
    route: string;
}

export interface OpenedPage {
    component: ComponentType<PageComponent>,
    data: { [key: string]: string | Function | Array<string | Function> | Object },
    id: string
}

export interface ClosedPage {
    id: string;
    result: any
}

export interface Message {
    message: string;
    messageSafe?: SafeHtml;
    footer: boolean;
    dismissed?: boolean;
    issue?: boolean;
    noDismissWhenClosePage?: boolean;
}

export interface PreviewData {
    isPreviewEnabled: boolean,
    drawData: any
}
export interface UiState {
    previewData: PreviewData;
    options: ConfiguratorOptions;
    steps: Step[];
    selectedStep?: string;
    selectStepCause?: 'tab' | 'click';
    openedPages: OpenedPage[];
    closedPages: ClosedPage[];
    openedFilterSheets: OpenedPage[];
    closedFilterSheets: ClosedPage[];
    parentConfigurationType: ConfigurationType | null;
    messages: Message[];
    loaded: boolean;
    fullscreen: boolean;
    changedToolbarTitle?: string;
    error?: any;
    colorStepMode: 'simple' | 'advanced' | 'door_extended';
    systemStepMode: 'list' | 'details';
    lightsGlazingStepMode: 'list' | 'extra';
    savingButton: boolean;
    returnButton: ReturnButtonVariant;
    additionalReturnButtons?: ReturnButton[];
    activeSearch: boolean;
    searchValue: string;
    focusInInput: boolean;
    currency: any;
    previewFocusedShutterId: number | null;
    rulesMode?: 'simple' | 'blockly';
}

export interface ConfiguratorState {
    uiState: UiState;
}

export interface ConfiguratorRootState {
    configurator: ConfiguratorState;
}

export interface ConfiguratorPartialState {
    readonly [CONFIGURATOR_KEY]: ConfiguratorState;
}
